import { getProfile } from './states';

export const services = {
  getProfile,
};
